import React, {useEffect, useState} from 'react';

import {observer} from 'mobx-react';
import {WebsiteModuleProps} from "../../models/website-module.props";
import {ExternalAd} from "../../../../core/components/ad/external-ad/external-ad";
import {EXTERNAL_AD_CONFIG} from "../../consts/external-ad-config";
import classNames from "classnames";
import styles from "../../styles/website.module.scss";
import {AD_DISPLAYS} from "../../../../core/consts";
import {useVoltaxPlayer} from "../../../../core/components/ad/minute-media-player/use-voltax-player";

export const WebsiteModuleStickyExternalAd = observer(({controller}: WebsiteModuleProps) => {
  const {
    state: {
      shouldDisplayStickyExternalAd,
      shouldRenderMinuteMediaPlayer,
      appState: {
        isBottomNavigationForAdVisible
      }
    },
  } = controller;

  const [isVisible, setIsVisible] = useState(shouldDisplayStickyExternalAd);
  const [isVoltaxPlayerSticky, setIsVoltaxPlayerSticky] = useState(false);

  const {state: {device: {isSmallView}}} = controller;

  useEffect(() => {
    setIsVisible(shouldDisplayStickyExternalAd);
  }, [shouldDisplayStickyExternalAd]);

  // When the Minute Media player is shown (A/B player group), shrink the mobile
  // sticky banner to 320x50 so it doesn't compete with the player.
  const mobileStickyConfig = shouldRenderMinuteMediaPlayer
    ? EXTERNAL_AD_CONFIG.MOBILE.STICKY.AD320X50
    : EXTERNAL_AD_CONFIG.MOBILE.STICKY.AD320X100;

  const externalAdProps = {
    controller,
    config: isSmallView ? mobileStickyConfig : EXTERNAL_AD_CONFIG.DESKTOP.STICKY.AD970X90,
    isMock: controller.state.appState.settings.config.adDisplay === AD_DISPLAYS.placeholders,
    shouldRenderClosingButton: false,
    className: classNames(styles.sticky_ad),
    onClose: () => setIsVisible(false),
  }

  const player = useVoltaxPlayer();
  useEffect(() => {
    if (!player) {
      return;
    }

    const handleFloatingChange = (params) => {
      setIsVoltaxPlayerSticky(params.isFloating);
    };

    player.on('floatingChange', handleFloatingChange);

    return () => {
      if (player && typeof player.off === 'function') {
        player.off('floatingChange', handleFloatingChange);
      }
    };
  }, [player]);

  return isVisible ? <div
    className={classNames(styles.sticky_ad_container, {[styles.bottom_navigation_visible]: isBottomNavigationForAdVisible, [styles.voltax_player_sticky]: isVoltaxPlayerSticky})}>
    <ExternalAd {...externalAdProps} /></div> : null;
});
